import React from 'react';
import { Rate } from 'antd';
import { StarRatingProps } from '../../@types/review';

const StarRating: React.FC<StarRatingProps> = ({
    rating,
    maxStars = 5,
    size = 'default',
    showCount = false
}) => {
    return (
        <div className="star-rating">
            <Rate
                disabled
                value={rating}
                count={maxStars}
                style={{ fontSize: '14px' }}
            />
            {showCount && (
                <span className="rating-text">({rating}/{maxStars})</span>
            )}
        </div>
    );
};

export default StarRating; 